import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ChartInfoIcon = ({ info, sx = {}, iconSize = 16 }) => {
  if (!info) {
    return null;
  }

  return (
    <Tooltip
      title={info}
      arrow
      placement="bottom-end"
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "0.875rem",
            maxWidth: 400,
            whiteSpace: "pre-wrap",
            bgcolor: "rgba(0, 0, 0, 0.87)",
          },
        },
      }}
    >
      <IconButton
        aria-label="chart information"
        sx={{ fontSize: iconSize, color: "text.secondary", ...sx }}
      >
        <InfoOutlinedIcon sx={{ fontSize: iconSize }} />
      </IconButton>
    </Tooltip>
  );
};

export default ChartInfoIcon;


